const pt = {
  nome: 'Configurações',
  papelFabrica: { dono: 'TI', administrador: 'Administrador', gestor: 'Gestor', operador: 'Operador', leitura: 'Leitura' },
  abas: {
    subsistemas: 'Sub-sistemas',
    empresa: 'Empresa',
    aparencia: 'Aparência',
    modos: 'Modo de operação',
    sequencias: 'Sequências',
    campos: 'Campos personalizados',
    'campos-telas': 'Campos das telas',
    visoes: 'Visões salvas',
    modelos: 'Modelos',
    estruturas: 'Etapas e funções',
    crm: 'CRM',
  },
  crm: {
    titulo: 'Configurações do CRM',
    intro: 'Funis e etapas (com o playbook), motivos de perda, fontes e campanhas, qualificação, questionários, modelos de proposta e workflows do comercial ficam nas Configurações do CRM.',
    abrir: 'Abrir as Configurações do CRM',
  },
  acoes: { novaEmpresa: 'Nova empresa', novaSequencia: 'Nova sequência', novoCampo: 'Novo campo', novoModelo: 'Novo modelo', desativar: 'Desativar', arquivar: 'Arquivar', remover: 'Remover', adicionar: 'Adicionar', renomear: 'Renomear' },
  empresa: {
    titulo: 'Empresas do grupo',
    razao: 'Razão social',
    fantasia: 'Nome fantasia',
    cnpj: 'CNPJ',
    pais: 'País',
    moeda: 'Moeda padrão',
    consulta: { buscando: 'Buscando os dados na Receita...', preenchido: 'Dados preenchidos pela consulta; confira antes de salvar', naoEncontrado: 'Não encontrado na consulta', falha: 'A consulta não respondeu; preencha à mão' },
    cep: 'CEP',
    logradouro: 'Logradouro',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Bairro',
    cidade: 'Cidade',
    uf: 'UF',
    endereco: 'Endereço',
    logo: 'Logo',
    enviarLogo: 'Enviar logo',
    trocarLogo: 'Trocar logo',
    removerLogo: 'Remover logo',
    semLogo: 'Sem logo',
    logoDica: 'Imagem PNG, JPG ou SVG de até 2 MB. A logo é um anexo da empresa.',
    logoGrande: 'A logo passa de 2 MB',
    logoTipo: 'Escolha uma imagem',
    vazio: 'Cadastre a empresa principal. Ela aparece nos documentos e nas sequências de numeração.',
    confirmarArquivar: 'Excluir esta empresa?',
    confirmarArquivarTexto: 'Nada é apagado: ela é arquivada e some das listas e do seletor. A última empresa ativa não pode ser excluída.',
    historico: 'Histórico da empresa',
    troca: {
      titulo: 'Troca de empresa/vertical',
      ajuda: 'Define como as pessoas deste workspace trabalham com as empresas (verticais) do grupo.',
      ligar: 'Trabalhar com troca de empresa/vertical',
      ligarAjuda: 'Ligado, o seletor de empresa aparece no perfil e cada pessoa pode trabalhar numa vertical só. Desligado, é um ambiente único: cada pessoa vê sempre todas as verticais liberadas para ela, o cadastro novo nasce em "Todas" (ou nas verticais dela, se for limitada) e os registros de um CNPJ só pedem a empresa no próprio formulário. O filtro "Vertical" das listas continua.',
      salvar: 'Salvar',
      descartar: 'Descartar',
    },
    exportacoes: {
      titulo: 'Arquivos já exportados de relatório sem acesso',
      ajuda: 'O que acontece com os arquivos que uma pessoa já exportou de um relatório quando ela perde a página do relatório ou a permissão do módulo.',
      bloquear: 'Bloquear os arquivos de quem perdeu o acesso',
      bloquearAjuda: 'Ligado (padrão), os arquivos somem da lista de exportações e o download é recusado enquanto a pessoa não tiver acesso; voltando o acesso, eles voltam (até expirar). Desligado, os arquivos ficam disponíveis até expirar. Vale para a exportação manual, o relatório salvo e o agendado; nada é apagado.',
      salvar: 'Salvar',
      descartar: 'Descartar',
    },
  },
  aparencia: {
    titulo: 'Aparência',
    ajuda: 'A cor de marca vale para todo o workspace. Tema e idioma padrão valem para quem ainda não escolheu o seu.',
    acento: 'Cor de marca',
    tema: 'Tema padrão',
    idioma: 'Idioma padrão',
    previa: 'Prévia ao vivo',
    previaTexto: 'Assim o botão principal, os destaques e as abas ficam com a cor escolhida.',
    botao: 'Cor do botão principal',
    aba: 'Aba ativa',
    destaque: 'Destaque',
    salvar: 'Salvar aparência',
    descartar: 'Descartar',
    cores: { verde: 'Verde Malgo', rosa: 'Rosa', roxo: 'Roxo', azul: 'Azul', ciano: 'Ciano', laranja: 'Laranja' },
    temas: { escuro: 'Escuro', claro: 'Claro' },
    idiomas: { pt: 'Português', en: 'English', es: 'Español' },
    historico: 'Histórico da aparência',
    de: 'de',
    para: 'para',
    modelos: {
      titulo: 'Modelos próprios',
      ajuda: 'Crie um modelo a partir de um dos modos, ajuste as cores e aplique no workspace.',
      vazio: 'Nenhum modelo criado ainda.',
      novo: 'Novo modelo',
      partida: 'Começar a partir de',
      nome: 'Nome do modelo',
      nomePadrao: 'Meu modelo',
      editar: 'Editar',
      aplicar: 'Aplicar a todos',
      emUso: 'Em uso',
      excluir: 'Excluir',
      excluirTitulo: 'Excluir este modelo?',
      excluirTexto: 'O workspace volta para a Maré se este modelo estiver em uso. Quem tiver este estilo fixado passa a ver a Maré até receber outro.',
      salvar: 'Salvar modelo',
      cancelar: 'Cancelar',
      claro: 'Claro',
      escuro: 'Escuro (Noite)',
      areaPagina: 'Página',
      areaBarra: 'Barra e menu',
      previa: 'Prévia',
      hexInvalido: 'Use um hexadecimal de seis dígitos, começando por cerquilha',
      contrasteOk: 'Contraste aprovado nos dois temas.',
      contrasteFalha_one: '1 combinação sem contraste suficiente. Ajuste para salvar.',
      contrasteFalha_other: '{{count}} combinações sem contraste suficiente. Ajuste para salvar.',
      salvo: 'Modelo salvo',
      contrasteItemSelo: 'Selo de {{frente}} sobre {{fundo}}: {{razao}}:1 (mínimo {{minimo}}:1)',
      contrasteItem: '{{frente}} sobre {{fundo}}: {{razao}}:1 (mínimo {{minimo}}:1)',
      aplicado: 'Modelo aplicado ao workspace',
      aplicarAjuda: 'Vale para quem segue o padrão do workspace. Para valer para todos, desligue a escolha pessoal no cartão acima.',
      previaTitulo: 'Visão geral',
      previaTexto: 'Texto de apoio do cartão',
      previaValor: 'R$ 93.540,80',
      previaLink: 'Ver detalhes',
      previaBotao: 'Salvar',
      previaSecundario: 'Cancelar',
      previaOk: 'Pago',
      previaAtencao: 'Vence hoje',
      previaErro: 'Vencido',
      previaMenu1: 'Início',
      previaMenu2: 'Comercial',
      previaMenu3: 'Atividades',
      tok: {
        fundo: 'Fundo',
        'superficie-1': 'Cartão',
        'superficie-2': 'Superfície 2',
        'superficie-3': 'Superfície 3',
        'tinta-1': 'Texto principal',
        'tinta-2': 'Texto de apoio',
        'tinta-3': 'Legenda',
        borda: 'Borda',
        'borda-campo': 'Borda de campo',
        campo: 'Fundo de campo',
        foco: 'Anel de foco',
        acento: 'Botão principal',
        'acento-forte': 'Destaque',
        'acento-hover': 'Botão ao passar o mouse',
        'acento-tinta': 'Texto do botão',
        azul: 'Link',
        verde: 'Positivo',
        perigo: 'Erro',
        dourado: 'Atenção',
        laranja: 'Atraso',
        apoio: 'Informação',
      },
    },
    estilo: {
      titulo: 'Estilo de interface do workspace',
      ajuda: 'Vale para quem não escolheu o seu e, com a escolha pessoal desligada, para todos.',
      permitir: 'Permitir que cada pessoa escolha o próprio estilo',
      permitirAjuda: 'Desligado, o cartão Estilo de Minha conta fica só para leitura e vale o do workspace (ou o fixado para a pessoa em Usuários).',
      salvar: 'Salvar estilo',
    },
    fonte: {
      titulo: 'Fonte do texto',
      ajuda: 'Vale para todo o workspace. Números e valores continuam na fonte de largura fixa, para as colunas não desalinharem.',
      padrao: 'Padrão',
      daEmpresa: 'Da empresa',
      sistema: 'Fonte do sistema',
      amostra: 'Ação rápida: código Il1O0, 25 itens, 98,5%, ñ ¿ ¡',
      permitir: 'Cada pessoa pode escolher a própria fonte',
      permitirAjuda: 'Em Minha conta, entre as prévias e as fontes enviadas aqui.',
      salvar: 'Salvar fonte',
      enviarTitulo: 'Enviar arquivo de fonte',
      enviarAjuda: 'woff2 até {{woff2}} KB, woff até {{woff}} KB, ttf e otf até {{ttf}} KB. No máximo 2 arquivos (regular e negrito, ou um variável).',
      arquivo: 'Arquivo de fonte',
      nome: 'Nome exibido',
      licenca: 'Tenho licença para uso e distribuição web desta fonte',
      licencaAviso: 'Fontes do sistema operacional e de pacotes de escritório costumam proibir o uso em páginas. O sistema recusa o arquivo marcado como de uso restrito.',
      enviar: 'Enviar fonte',
      enviada: 'Fonte enviada',
      removerTitulo: 'Remover fonte',
      removerTexto: 'A fonte {{nome}} sai da lista. Quem a usava volta para a fonte do workspace.',
    },
    marca: {
      titulo: 'Marca',
      ajuda: 'Nome e logo exibidos no menu e no ícone da aba do navegador.',
      nome: 'Nome exibido',
      nomeAjuda: 'Vazio, aparece MalgoOS.',
      salvarNome: 'Salvar nome',
      logo: 'Logo',
      logoAjuda: 'PNG ou WebP até 256 KB, de preferência quadrada. SVG não é aceito.',
      logoEnviada: 'Logo atualizada',
      enviando: 'Enviando',
      removerLogo: 'Remover logo',
    },
  },
  sequencias: {
    titulo: 'Sequências de numeração',
    ajuda: 'Cada documento pega o próximo número sem buraco nem repetição. O próximo número só pode subir.',
    codigo: 'Código',
    codigoDica: 'Usado pelos módulos: fatura, conta_pagar, pedido_compra, contrato',
    empresa: 'Empresa',
    todasEmpresas: 'Todas as empresas',
    prefixo: 'Prefixo',
    prefixoDica: 'Use {ano} para o ano corrente. Ex.: FAT-{ano}-',
    digitos: 'Dígitos',
    proximo: 'Próximo número',
    proximoDica: 'Só pode ser igual ou maior que o atual',
    proximoInvalido: 'O próximo número começa em 1',
    digitosInvalido: 'Use de 1 a 12 dígitos',
    reinicio: 'Reiniciar todo ano',
    proxima: 'Próxima numeração',
    previa: 'Prévia',
    vazio: 'Crie a primeira sequência. Sem ela, o sistema usa um padrão com três letras do código.',
    novaTitulo: 'Nova sequência',
    editarTitulo: 'Editar sequência',
    historico: 'Histórico das sequências',
    sim: 'Reinicia',
    nao: 'Contínua',
  },
  campos: {
    titulo: 'Campos personalizados',
    ajuda: 'Os campos aparecem no formulário e na tabela da entidade escolhida. Só entram entidades de módulos instalados.',
    entidade: 'Entidade',
    chave: 'Chave',
    chaveDica: 'Nome interno: minúsculas, números e sublinhado. Não muda depois.',
    rotulo: 'Rótulo',
    tipo: 'Tipo',
    opcoes: 'Opções da lista',
    opcoesDica: 'Uma opção por linha',
    obrigatorio: 'Obrigatório',
    ordem: 'Ordem',
    tipos: { texto: 'Texto', numero: 'Número', data: 'Data', lista: 'Lista', booleano: 'Sim ou não', telefone: 'Telefone', documento: 'CPF ou CNPJ', email: 'E-mail', cep: 'CEP', dinheiro: 'Dinheiro', texto_longo: 'Texto longo' },
    ajudaCampo: 'Ajuda', ajudaCampoDica: 'Aparece sob o campo no formulário (até 200 caracteres).', condicao: 'Mostrar quando', condicaoDica: 'Opcional: o campo só aparece quando este outro campo tem o valor escolhido.', condicaoValor: 'For igual a', condicaoSelo: 'Condicional', soNestaAba: 'Só em {{aba}}', soNestaAbaDica: 'Sem marcar, o campo vale nas duas abas (Empresas e Contatos).', soNaAba: 'Este campo vale só em {{aba}}.', nasDuasAbas: 'Nas duas abas',
    condicaoFixos: { tipo: 'Tipo (pessoa ou empresa)', e_cliente: 'É cliente', e_fornecedor: 'É fornecedor', e_parceiro: 'É indicador / parceiro comercial' },
    condicaoValores: { pessoa: 'Pessoa', empresa: 'Empresa', true: 'Sim', false: 'Não' },
    vazio: 'Nenhum campo nesta entidade. Crie o primeiro para ele aparecer nos formulários.',
    novoTitulo: 'Novo campo personalizado',
    editarTitulo: 'Editar campo',
    tipoFixo: 'Chave e tipo não mudam, porque os valores já gravados dependem deles.',
    sensivel: 'Dado sensível (oculto no modo discreto)',
    sensivelDica: 'Com o modo discreto ligado, o valor some da ficha, da tabela, do formulário e da auditoria.',
    sensivelSempre: 'Número, data, dinheiro, documento, telefone, e-mail e CEP ficam sempre ocultos no modo discreto.',
    sensivelSelo: 'Sensível',
    confirmarDesativar: 'Desativar este campo?',
    confirmarDesativarTexto: 'Ele some dos formulários e das tabelas. Os valores já gravados ficam guardados.',
    semEntidades: 'Nenhum módulo instalado aceita campos personalizados.',
    historico: 'Histórico dos campos',
    entidades: {
      cadastros_parceiro: 'Parceiros (cadastros)',
      cadastros_projeto: 'Projetos (cadastros)',
      pipeline_oportunidade: 'Oportunidades (pipeline)',
      estoque_produto: 'Produtos (estoque)',
      pessoas_funcionario: 'Funcionários (pessoas)',
      agenda_agendamento: 'Agendamentos (agenda)',
      financeiro_lancamento: 'Lançamentos (financeiro)',
      contas_documento: 'Documentos (contas)',
      compras_pedido: 'Pedidos (compras)',
      cadastros_servico: 'Serviços (cadastros)',
      assinaturas_contrato: 'Contratos (assinaturas)',
      compras_requisicao: 'Requisições (compras)',
      folha_beneficio: 'Benefícios (folha)',
      folha_evento: 'Eventos (folha)',
      cadastros_forma_pagamento: 'Formas de pagamento (cadastros)',
      cadastros_condicao_pagamento: 'Condições de pagamento (cadastros)',
      compras_compra: 'Compras diretas (compras)',
    },
  },
  visoes: {
    titulo: 'Minhas visões salvas',
    ajuda: 'Visões são filtros, colunas e ordenação que você salvou nas tabelas. Só você edita e remove as suas; as que você compartilha aparecem para quem as recebeu.',
    compartilhamentos: { papeis: 'Compartilhada com papéis', pessoas: 'Compartilhada com pessoas', workspace: 'Compartilhada com todo o workspace' },
    emRelatorios: 'Em Relatórios',
    tela: 'Tela',
    todasTelas: 'Todas as telas',
    padrao: 'Padrão',
    colunas_one: '{{count}} coluna', colunas_other: '{{count}} colunas',
    vazio: 'Você ainda não salvou nenhuma visão. Nas tabelas, use o ícone de marcador para salvar a visão atual.',
    confirmarRemover: 'Remover esta visão?',
    confirmarRemoverTexto: 'Ela deixa de aparecer na tabela. Os dados não mudam.',
    historico: 'Histórico das visões',
  },
  modelos: {
    titulo: 'Modelos de mensagem e documento',
    ajuda: 'Os módulos buscam o modelo pelo código e trocam as variáveis pelos dados do cliente.',
    codigo: 'Código',
    codigoDica: 'Não muda depois, porque outros módulos usam este código',
    nome: 'Nome',
    tipo: 'Tipo',
    canal: 'Canal',
    assunto: 'Assunto',
    corpo: 'Corpo',
    ativo: 'Ativo',
    variaveis: 'Variáveis',
    variaveisDica: 'Clique para inserir no corpo',
    previa: 'Prévia com dados de exemplo',
    previaCarregando: 'Montando a prévia',
    tipos: { mensagem: 'Mensagem', documento: 'Documento' },
    canais: { email: 'E-mail', whatsapp: 'WhatsApp' },
    var: { nome: 'Nome do cliente', valor: 'Valor', vencimento: 'Vencimento ou data de referência', link: 'Link', pix: 'Pix copia e cola (da cobrança gerada)', linha_digitavel: 'Linha digitável do boleto (da cobrança gerada)', pix_copia_e_cola: 'Pix copia e cola (Asaas ou Pix Sicredi)', link_portal: 'Link da fatura no Portal (cliente com acesso)', como_pagar: 'Como pagar: link, Pix, linha digitável ou Portal (o que houver)' },
    vazio: 'Crie o primeiro modelo para padronizar cobranças, lembretes e boas-vindas.',
    novoTitulo: 'Novo modelo',
    editarTitulo: 'Editar modelo',
    confirmarArquivar: 'Arquivar este modelo?',
    confirmarArquivarTexto: 'Quem buscar este código deixa de receber o texto.',
    inativo: 'Inativo',
    historico: 'Histórico dos modelos',
  },
  estruturas: { tipo: 'Tipo', tipos: { receita: 'Receita', despesa: 'Despesa' },
    titulo: 'Etapas e funções',
    ajuda: 'Estas listas pertencem a outros módulos. Cada uma é editada num lugar só (as funções, em Pessoas > Funções); a regra e o histórico continuam nos módulos donos.',
    etapas: 'Etapas do pipeline',
    funcoes: 'Funções de pessoas',
    editarEm: { funcoes: 'Editar em Pessoas > Funções' },
    nomeNovo: 'Nome',
    funil: 'Funil',
    indisponivel: 'Este módulo ainda não expõe a lista para edição aqui. Quando expuser, ela aparece nesta seção.',
    semModulos: 'Nenhum módulo com listas editáveis está instalado (pipeline ou pessoas).',
    vazio: 'Nada cadastrado ainda. Adicione o primeiro item.',
    confirmarRemover: 'Remover este item?',
    confirmarRemoverTexto: 'A regra de exclusão é do módulo dono; se houver registros usando o item, ele avisa.',
  },
  // D1 (sub-sistemas, L3): Admin > Configurações > Sub-sistemas.
  subsistemas: {
    titulo: 'Sub-sistemas',
    ajuda: 'Sub-sistema é um filtro de menu: decide onde cada página aparece. Quem pode abrir a página continua sendo a permissão do papel, e os dados são os mesmos em todos.',
    usar: 'Usar sub-sistemas neste workspace',
    usarAjuda: 'Desligado, o menu é o de sempre para todos. Ligado, cada pessoa escolhe a empresa e o sub-sistema ao entrar.',
    usarSoTodas: 'Só quem vê todas as empresas liga ou desliga os sub-sistemas do workspace. Com eles desligados, a arrumação da sua empresa fica guardada, mas o menu não muda.',
    novoDesenho: 'Novo desenho',
    novoDesenhoAjuda: 'Casca do CRM novo para todos deste workspace: sub-sistema no topo, workspace e empresa no perfil, menu lateral só com as páginas do sub-sistema. Só vale com os sub-sistemas ligados.',
    valerPara: 'Valer para',
    oWorkspace: 'O workspace (todas as empresas)',
    aEmpresa: 'Esta empresa: {{nome}}',
    empresaAjuda: 'A arrumação da empresa vale por cima da do workspace.',
    subsistema: 'Sub-sistema',
    ligadoEm: '{{nome}} ligado',
    ligadoAjuda: 'Desligado, ele não aparece na tela inicial.',
    comum: 'Admin, Configurações e o Chat da equipe aparecem em todos os sub-sistemas.',
    paginasDe: '{{ligadas}} de {{total}} páginas',
    paginaCasca: 'Barra lateral',
    parcial: 'Parcial',
    modulo: '{{nome}} em {{subsistema}}',
    pagina: '{{pagina}} em {{subsistema}}',
    avisoSemLugar_one: '{{count}} página está fora de todos os sub-sistemas ligados e não aparece nos menus.',
    avisoSemLugar_other: '{{count}} páginas estão fora de todos os sub-sistemas ligados e não aparecem nos menus.',
    restaurarSub: 'Restaurar padrão de {{nome}}',
    restaurarTudo: 'Restaurar padrão geral',
    salvar: 'Salvar',
    salvo: 'Sub-sistemas salvos',
    semMudanca: 'Nada mudou',
    historico: 'Histórico dos sub-sistemas',
    trocaWorkspace: 'Arrumação do workspace',
    trocaEmpresa: 'Arrumação da empresa {{nome}}',
    semLugarTitulo: 'Páginas sem lugar nos menus',
    semLugarTexto: 'Estas páginas ficam fora de todos os sub-sistemas ligados e deixam de aparecer nos menus:',
    ciente: 'Estou ciente de que estas páginas deixam de aparecer nos menus. Os dados continuam guardados e posso religá-las aqui.',
    confirmar: 'Confirmar e salvar',
    semPermissao: 'Sem permissão para configurar os sub-sistemas.',
  },
  // D2 (ícones nas abas): seção de Admin > Configurações > Sub-sistemas.
  icones: {
    titulo: 'Ícones nas abas',
    ajuda: 'Ícone antes do nome das abas e sub-abas das páginas (o menu lateral não muda). Vale para todo o workspace.',
    ativo: 'Mostrar ícones nas abas',
    celular: 'Mostrar também no celular',
    celularAjuda: 'Desligado, os ícones aparecem só em telas maiores; no celular as abas ficam só com o texto.',
    trocar: 'Trocar o ícone de uma aba',
    primeiroNivel: 'Primeiro nível (módulos e grupos)',
    iconeDe: 'Ícone de {{nome}}',
    padrao: 'Padrão ({{nome}})',
    // Captura do Gustavo (13/10): o nome de cada ícone no idioma do app (o do lucide, em inglês, não aparece na tela).
    nomes: { Activity: 'Atividade', ArrowDownLeft: 'Seta de entrada', ArrowLeftRight: 'Setas para os dois lados', ArrowRightLeft: 'Troca', ArrowUpRight: 'Seta de saída', BadgeCheck: 'Selo de aprovado', Banknote: 'Cédula', Bell: 'Sino', BookOpen: 'Livro aberto', Bookmark: 'Marcador', Bot: 'Robô', Boxes: 'Caixas', Briefcase: 'Pasta de trabalho', BriefcaseBusiness: 'Maleta executiva', Building: 'Prédio', Building2: 'Prédios', Calendar: 'Calendário', CalendarCheck: 'Calendário com visto', CalendarClock: 'Calendário com relógio', CalendarCog: 'Calendário com engrenagem', CalendarDays: 'Calendário com dias', CalendarRange: 'Período no calendário', Camera: 'Câmera', ChartColumn: 'Gráfico de colunas', ChartLine: 'Gráfico de linha', ClipboardCheck: 'Prancheta com visto', ClipboardList: 'Prancheta com lista', Clock: 'Relógio', Code: 'Código', Contact: 'Contato', CreditCard: 'Cartão de crédito', Download: 'Baixar', Factory: 'Fábrica', FileCheck2: 'Arquivo com visto', FileLock: 'Arquivo com cadeado', FileMinus: 'Arquivo com menos', FileQuestion: 'Arquivo com interrogação', FileSignature: 'Arquivo com assinatura', FileSpreadsheet: 'Planilha', FileText: 'Documento', Folder: 'Pasta', FolderKanban: 'Pasta com quadro', Gauge: 'Medidor', Gift: 'Presente', GraduationCap: 'Capelo', HandCoins: 'Mão com moedas', Handshake: 'Aperto de mão', Hash: 'Cerquilha', Heart: 'Coração', History: 'Histórico', House: 'Casa', IdCard: 'Crachá', Inbox: 'Caixa de entrada', Kanban: 'Quadro', KeyRound: 'Chave', Landmark: 'Banco', LayoutDashboard: 'Painel', LayoutGrid: 'Grade', LayoutTemplate: 'Modelo de página', LifeBuoy: 'Boia', List: 'Lista', ListTodo: 'Lista de tarefas', ListTree: 'Lista em árvore', Lock: 'Cadeado', Mail: 'Envelope', Megaphone: 'Megafone', MessageCircle: 'Balão de conversa', MessagesSquare: 'Mensagens', MonitorSmartphone: 'Computador e celular', Network: 'Rede', Package: 'Pacote', PackagePlus: 'Pacote com mais', Palette: 'Paleta de cores', Percent: 'Porcentagem', PiggyBank: 'Cofrinho', Plug: 'Tomada', Puzzle: 'Quebra-cabeça', Receipt: 'Recibo', ReceiptText: 'Recibo com texto', Repeat: 'Repetir', Route: 'Rota', Ruler: 'Régua', Scale: 'Balança', Settings2: 'Ajustes', Share2: 'Compartilhar', ShieldCheck: 'Escudo com visto', ShoppingCart: 'Carrinho de compras', SlidersHorizontal: 'Controles deslizantes', Star: 'Estrela', Store: 'Loja', Tags: 'Etiquetas', Target: 'Alvo', TextCursorInput: 'Campo de texto', ThumbsDown: 'Polegar para baixo', ToggleLeft: 'Interruptor', Trash2: 'Lixeira', TrendingUp: 'Tendência de alta', TriangleAlert: 'Alerta', Truck: 'Caminhão', UserCheck: 'Pessoa com visto', UserCog: 'Pessoa com engrenagem', UserRound: 'Pessoa', Users: 'Pessoas', Wallet: 'Carteira', Warehouse: 'Armazém', Webhook: 'Webhook', Workflow: 'Fluxo', Zap: 'Raio' },
  },
  // D3 (sub-sistemas do tipo link externo): seção de Admin > Configurações > Sub-sistemas.
  links: {
    titulo: 'Links externos',
    ajuda: 'Sistemas de fora (como o escritório virtual e o cofre de senhas) que aparecem na tela inicial ao lado dos sub-sistemas e abrem em nova aba ou, quando permitido, dentro do MalgoOS. Só endereços https.',
    vazio: 'Nenhum link cadastrado.',
    nome: 'Nome',
    url: 'Endereço',
    urlInvalida: 'Use um endereço https:// completo',
    papeis: 'Quem vê',
    papeisAjuda: 'Nenhum marcado: todos do workspace. Esconder o link não protege o destino.',
    adicionar: 'Adicionar link',
    remover: 'Remover {{nome}}',
    semNome: 'link sem nome',
    embutir: 'Abrir dentro do MalgoOS',
    embutirAjuda: 'Abre numa página do sistema, com o menu ao lado, em vez de nova aba. No celular, continua em nova aba.',
    embutirMotivo: {
      url: 'Informe um endereço https:// válido para poder abrir dentro do MalgoOS.',
      host: 'Só endereços permitidos abrem dentro do MalgoOS (hoje: {{hosts}}); este abre em nova aba.',
      caminho: 'O painel /admin abre só em aba própria.',
    },
  },
  camposTelas: {
    titulo: 'Campos das telas',
    ajuda: 'Escolha, para cada tela de cadastro, quais campos aparecem e quais são obrigatórios. Esconder não apaga o que já foi gravado. Campo com cadeado entra em regra, relatório ou integração e não muda.',
    tela: 'Tela',
    aparece: 'Aparece',
    obrigatorio: 'Obrigatório',
    escondido: 'Escondido',
    padrao: 'Padrão',
    travado: 'Travado',
    travadoDica: 'Entra em regra, relatório, integração ou cálculo',
    salvar: 'Salvar campos',
    descartar: 'Descartar',
    salvo: 'Campos da tela salvos',
    vazio: 'Nenhum módulo instalado tem tela com campos configuráveis.',
    semPermissao: 'Só quem tem a permissão de configurar os campos das telas vê esta aba (TI e Administrador; outro papel em Pessoas > Pessoas > Usuários e acessos > Papéis).',
    soQuemVeTodas: 'Vale para todo o workspace: só quem vê todas as empresas grava.',
    historico: 'Histórico dos campos das telas',
    troca: '{{tela}}: {{lista}}',
  },
  modoOperacao: {
    titulo: 'Modo de operação',
    ajuda: 'Escolha quão fundo cada módulo vai neste workspace. Trocar não apaga nada: o que já foi registrado continua consultável.',
    atual: 'Atual',
    padrao: 'padrão do módulo',
    oQueMuda: 'O que muda',
    impede: 'Para trocar, encerre antes: {{lista}}',
    salvar: 'Salvar modo',
    salvo: 'Modo de operação salvo',
    vazio: 'Nenhum módulo instalado tem modo de operação para escolher.',
    semPermissao: 'Só quem edita as Configurações troca o modo de operação.',
    historico: 'Histórico de trocas',
    troca: '{{modulo}}: {{de}} para {{para}}',
  },
  historico: {
    titulo: 'Histórico de alterações',
    vazio: 'Nenhuma alteração registrada ainda.',
    por: 'por {{nome}}',
    sistema: 'sistema',
    chaveApi: 'chave de API',
    sem: 'sem detalhes',
    removido: '(removido)',
    acoes: { criar: 'Criou', editar: 'Editou', arquivar: 'Arquivou', desativar: 'Desativou', definir: 'Definiu', remover: 'Removeu', distribuir: 'Distribuiu', devolver: 'Devolveu ao grupo' },
  },
};

type Dic = typeof pt;

const en: Dic = {
  nome: 'Settings',
  papelFabrica: { dono: 'IT', administrador: 'Administrator', gestor: 'Manager', operador: 'Operator', leitura: 'Read only' },
  abas: {
    subsistemas: 'Subsystems',
    empresa: 'Company',
    aparencia: 'Appearance',
    modos: 'Operating mode',
    sequencias: 'Sequences',
    campos: 'Custom fields',
    'campos-telas': 'Screen fields',
    visoes: 'Saved views',
    modelos: 'Templates',
    estruturas: 'Stages and roles',
    crm: 'CRM',
  },
  crm: {
    titulo: 'CRM settings',
    intro: 'Pipelines and stages (with the playbook), loss reasons, sources and campaigns, qualification, questionnaires, proposal templates and sales workflows are in the CRM settings.',
    abrir: 'Open the CRM settings',
  },
  acoes: { novaEmpresa: 'New company', novaSequencia: 'New sequence', novoCampo: 'New field', novoModelo: 'New template', desativar: 'Deactivate', arquivar: 'Archive', remover: 'Remove', adicionar: 'Add', renomear: 'Rename' },
  empresa: {
    titulo: 'Group companies',
    razao: 'Legal name',
    fantasia: 'Trade name',
    cnpj: 'CNPJ (tax ID)',
    pais: 'Country',
    moeda: 'Default currency',
    consulta: { buscando: 'Looking up the data...', preenchido: 'Filled in by the lookup; check before saving', naoEncontrado: 'Not found in the lookup', falha: 'The lookup did not answer; fill in by hand' },
    cep: 'ZIP code',
    logradouro: 'Street',
    numero: 'Number',
    complemento: 'Complement',
    bairro: 'District',
    cidade: 'City',
    uf: 'State',
    endereco: 'Address',
    logo: 'Logo',
    enviarLogo: 'Upload logo',
    trocarLogo: 'Change logo',
    removerLogo: 'Remove logo',
    semLogo: 'No logo',
    logoDica: 'PNG, JPG or SVG image up to 2 MB. The logo is an attachment of the company.',
    logoGrande: 'The logo is over 2 MB',
    logoTipo: 'Choose an image',
    vazio: 'Add the main company. It appears on documents and in numbering sequences.',
    confirmarArquivar: 'Delete this company?',
    confirmarArquivarTexto: 'Nothing is erased: it is archived and leaves the lists and the selector. The last active company cannot be deleted.',
    historico: 'Company history',
    troca: {
      titulo: 'Company/business unit switching',
      ajuda: 'Sets how people in this workspace work with the group companies (business units).',
      ligar: 'Work with company/business unit switching',
      ligarAjuda: 'On, the company selector shows in the profile and each person can work in one business unit. Off, it is a single environment: each person always sees all the business units they have access to, new records are created in "All" (or in their own business units, if limited) and single-company records (one tax ID) ask for the company in the form itself. The "Business unit" list filter stays.',
      salvar: 'Save',
      descartar: 'Discard',
    },
    exportacoes: {
      titulo: 'Report files already exported without access',
      ajuda: 'What happens to the files a person has already exported from a report when they lose the report page or the module permission.',
      bloquear: 'Block the files of people who lost access',
      bloquearAjuda: 'On (default), the files leave the exports list and the download is refused while the person has no access; when access comes back, so do the files (until they expire). Off, the files stay available until they expire. Applies to manual exports, saved reports and scheduled reports; nothing is erased.',
      salvar: 'Save',
      descartar: 'Discard',
    },
  },
  aparencia: {
    titulo: 'Appearance',
    ajuda: 'The brand color applies to the whole workspace. Default theme and language apply to people who have not chosen their own yet.',
    acento: 'Brand color',
    tema: 'Default theme',
    idioma: 'Default language',
    previa: 'Live preview',
    previaTexto: 'This is how the main button, highlights and tabs look with the chosen color.',
    botao: 'Main button color',
    aba: 'Active tab',
    destaque: 'Highlight',
    salvar: 'Save appearance',
    descartar: 'Discard',
    cores: { verde: 'Malgo green', rosa: 'Pink', roxo: 'Purple', azul: 'Blue', ciano: 'Cyan', laranja: 'Orange' },
    temas: { escuro: 'Dark', claro: 'Light' },
    idiomas: { pt: 'Português', en: 'English', es: 'Español' },
    historico: 'Appearance history',
    de: 'from',
    para: 'to',
    modelos: {
      titulo: 'Custom models',
      ajuda: 'Create a model from one of the modes, adjust the colors and apply it to the workspace.',
      vazio: 'No models yet.',
      novo: 'New model',
      partida: 'Start from',
      nome: 'Model name',
      nomePadrao: 'My model',
      editar: 'Edit',
      aplicar: 'Apply to all',
      emUso: 'In use',
      excluir: 'Delete',
      excluirTitulo: 'Delete this model?',
      excluirTexto: 'The workspace goes back to Tide if this model is in use. People fixed on this style see Tide until they get another one.',
      salvar: 'Save model',
      cancelar: 'Cancel',
      claro: 'Light',
      escuro: 'Dark (Night)',
      areaPagina: 'Page',
      areaBarra: 'Bar and menu',
      previa: 'Preview',
      hexInvalido: 'Use a six-digit hex value, starting with a hash sign',
      contrasteOk: 'Contrast approved in both themes.',
      contrasteFalha_one: '1 color pair without enough contrast. Adjust it to save.',
      contrasteFalha_other: '{{count}} color pairs without enough contrast. Adjust them to save.',
      salvo: 'Model saved',
      contrasteItemSelo: '{{frente}} badge on {{fundo}}: {{razao}}:1 (minimum {{minimo}}:1)',
      contrasteItem: '{{frente}} on {{fundo}}: {{razao}}:1 (minimum {{minimo}}:1)',
      aplicado: 'Model applied to the workspace',
      aplicarAjuda: 'Applies to people following the workspace default. To apply to everyone, turn off personal choice in the card above.',
      previaTitulo: 'Overview',
      previaTexto: 'Card supporting text',
      previaValor: 'R$ 93,540.80',
      previaLink: 'See details',
      previaBotao: 'Save',
      previaSecundario: 'Cancel',
      previaOk: 'Paid',
      previaAtencao: 'Due today',
      previaErro: 'Overdue',
      previaMenu1: 'Home',
      previaMenu2: 'Sales',
      previaMenu3: 'Activities',
      tok: {
        fundo: 'Background',
        'superficie-1': 'Card',
        'superficie-2': 'Surface 2',
        'superficie-3': 'Surface 3',
        'tinta-1': 'Main text',
        'tinta-2': 'Supporting text',
        'tinta-3': 'Caption',
        borda: 'Border',
        'borda-campo': 'Field border',
        campo: 'Field background',
        foco: 'Focus ring',
        acento: 'Main button',
        'acento-forte': 'Highlight',
        'acento-hover': 'Button on hover',
        'acento-tinta': 'Button text',
        azul: 'Link',
        verde: 'Positive',
        perigo: 'Error',
        dourado: 'Attention',
        laranja: 'Late',
        apoio: 'Information',
      },
    },
    estilo: {
      titulo: 'Workspace interface style',
      ajuda: 'Applies to people who did not pick their own and, with personal choice off, to everyone.',
      permitir: 'Let each person choose their own style',
      permitirAjuda: 'When off, the Style card in My account is read-only and the workspace style (or the one fixed for the person in Users) applies.',
      salvar: 'Save style',
    },
    fonte: {
      titulo: 'Text font',
      ajuda: 'Applies to the whole workspace. Numbers and amounts stay in the fixed width font, so columns stay aligned.',
      padrao: 'Default',
      daEmpresa: 'Company',
      sistema: 'System font',
      amostra: 'Quick action: code Il1O0, 25 items, 98.5%, ñ ¿ ¡',
      permitir: 'Each person can pick their own font',
      permitirAjuda: 'In My account, among the previews and the fonts uploaded here.',
      salvar: 'Save font',
      enviarTitulo: 'Upload font file',
      enviarAjuda: 'woff2 up to {{woff2}} KB, woff up to {{woff}} KB, ttf and otf up to {{ttf}} KB. At most 2 files (regular and bold, or one variable).',
      arquivo: 'Font file',
      nome: 'Display name',
      licenca: 'I have a license to use and distribute this font on the web',
      licencaAviso: 'Fonts from the operating system and office suites often forbid use on web pages. The system refuses files marked as restricted.',
      enviar: 'Upload font',
      enviada: 'Font uploaded',
      removerTitulo: 'Remove font',
      removerTexto: 'The font {{nome}} leaves the list. Anyone using it goes back to the workspace font.',
    },
    marca: {
      titulo: 'Brand',
      ajuda: 'Name and logo shown in the menu and in the browser tab icon.',
      nome: 'Display name',
      nomeAjuda: 'When empty, MalgoOS is shown.',
      salvarNome: 'Save name',
      logo: 'Logo',
      logoAjuda: 'PNG or WebP up to 256 KB, preferably square. SVG is not accepted.',
      logoEnviada: 'Logo updated',
      enviando: 'Uploading',
      removerLogo: 'Remove logo',
    },
  },
  sequencias: {
    titulo: 'Numbering sequences',
    ajuda: 'Each document gets the next number with no gaps and no repeats. The next number can only go up.',
    codigo: 'Code',
    codigoDica: 'Used by modules: fatura, conta_pagar, pedido_compra, contrato',
    empresa: 'Company',
    todasEmpresas: 'All companies',
    prefixo: 'Prefix',
    prefixoDica: 'Use {ano} for the current year. E.g. FAT-{ano}-',
    digitos: 'Digits',
    proximo: 'Next number',
    proximoDica: 'Must be equal to or greater than the current one',
    proximoInvalido: 'The next number starts at 1',
    digitosInvalido: 'Use 1 to 12 digits',
    reinicio: 'Restart every year',
    proxima: 'Next numbering',
    previa: 'Preview',
    vazio: 'Create the first sequence. Without it, the system uses a default with three letters of the code.',
    novaTitulo: 'New sequence',
    editarTitulo: 'Edit sequence',
    historico: 'Sequence history',
    sim: 'Restarts',
    nao: 'Continuous',
  },
  campos: {
    titulo: 'Custom fields',
    ajuda: 'Fields appear on the form and table of the chosen entity. Only entities of installed modules are listed.',
    entidade: 'Entity',
    chave: 'Key',
    chaveDica: 'Internal name: lowercase letters, numbers and underscore. It does not change later.',
    rotulo: 'Label',
    tipo: 'Type',
    opcoes: 'List options',
    opcoesDica: 'One option per line',
    obrigatorio: 'Required',
    ordem: 'Order',
    tipos: { texto: 'Text', numero: 'Number', data: 'Date', lista: 'List', booleano: 'Yes or no', telefone: 'Phone', documento: 'Tax ID (CPF or CNPJ)', email: 'E-mail', cep: 'ZIP code', dinheiro: 'Money', texto_longo: 'Long text' },
    ajudaCampo: 'Help', ajudaCampoDica: 'Shows under the field in the form (up to 200 characters).', condicao: 'Show when', condicaoDica: 'Optional: the field only shows when this other field has the chosen value.', condicaoValor: 'Equals', condicaoSelo: 'Conditional', soNestaAba: 'Only in {{aba}}', soNestaAbaDica: 'Unchecked, the field applies to both tabs (Companies and Contacts).', soNaAba: 'This field applies only to {{aba}}.', nasDuasAbas: 'In both tabs',
    condicaoFixos: { tipo: 'Type (person or company)', e_cliente: 'Is customer', e_fornecedor: 'Is supplier', e_parceiro: 'Is referrer / business partner' },
    condicaoValores: { pessoa: 'Person', empresa: 'Company', true: 'Yes', false: 'No' },
    vazio: 'No fields on this entity. Create the first one to show it on forms.',
    novoTitulo: 'New custom field',
    editarTitulo: 'Edit field',
    tipoFixo: 'Key and type do not change, because saved values depend on them.',
    sensivel: 'Sensitive data (hidden in discreet mode)',
    sensivelDica: 'With discreet mode on, the value is hidden on the record, the table, the form and the audit log.',
    sensivelSempre: 'Numbers, dates, money, tax IDs, phones, e-mails and ZIP codes are always hidden in discreet mode.',
    sensivelSelo: 'Sensitive',
    confirmarDesativar: 'Deactivate this field?',
    confirmarDesativarTexto: 'It leaves forms and tables. Saved values are kept.',
    semEntidades: 'No installed module accepts custom fields.',
    historico: 'Field history',
    entidades: {
      cadastros_parceiro: 'Partners (records)',
      cadastros_projeto: 'Projects (records)',
      pipeline_oportunidade: 'Opportunities (pipeline)',
      estoque_produto: 'Products (inventory)',
      pessoas_funcionario: 'Employees (people)',
      agenda_agendamento: 'Appointments (calendar)',
      financeiro_lancamento: 'Entries (finance)',
      contas_documento: 'Documents (accounts)',
      compras_pedido: 'Orders (purchasing)',
      cadastros_servico: 'Services (records)',
      assinaturas_contrato: 'Contracts (subscriptions)',
      compras_requisicao: 'Requisitions (purchasing)',
      folha_beneficio: 'Benefits (payroll)',
      folha_evento: 'Events (payroll)',
      cadastros_forma_pagamento: 'Payment methods (records)',
      cadastros_condicao_pagamento: 'Payment terms (records)',
      compras_compra: 'Direct purchases (purchasing)',
    },
  },
  visoes: {
    titulo: 'My saved views',
    ajuda: 'Views are filters, columns and sorting you saved on tables. Only you edit and remove yours; the ones you share appear to whoever received them.',
    compartilhamentos: { papeis: 'Shared with roles', pessoas: 'Shared with people', workspace: 'Shared with the whole workspace' },
    emRelatorios: 'In Reports',
    tela: 'Screen',
    todasTelas: 'All screens',
    padrao: 'Default',
    colunas_one: '{{count}} column', colunas_other: '{{count}} columns',
    vazio: 'You have not saved any view yet. On tables, use the bookmark icon to save the current view.',
    confirmarRemover: 'Remove this view?',
    confirmarRemoverTexto: 'It stops appearing on the table. The data does not change.',
    historico: 'View history',
  },
  modelos: {
    titulo: 'Message and document templates',
    ajuda: 'Modules look up the template by code and replace the variables with customer data.',
    codigo: 'Code',
    codigoDica: 'Does not change later, because other modules use this code',
    nome: 'Name',
    tipo: 'Type',
    canal: 'Channel',
    assunto: 'Subject',
    corpo: 'Body',
    ativo: 'Active',
    variaveis: 'Variables',
    variaveisDica: 'Click to insert into the body',
    previa: 'Preview with sample data',
    previaCarregando: 'Building the preview',
    tipos: { mensagem: 'Message', documento: 'Document' },
    canais: { email: 'E-mail', whatsapp: 'WhatsApp' },
    var: { nome: 'Customer name', valor: 'Amount', vencimento: 'Due or reference date', link: 'Link', pix: 'Pix copy and paste code (from the charge)', linha_digitavel: 'Boleto digitable line (from the charge)', pix_copia_e_cola: 'Pix copy and paste code (Asaas or Sicredi Pix)', link_portal: 'Invoice link in the Portal (customer with access)', como_pagar: 'How to pay: link, Pix, digitable line or Portal (whatever exists)' },
    vazio: 'Create the first template to standardize billing, reminders and welcome messages.',
    novoTitulo: 'New template',
    editarTitulo: 'Edit template',
    confirmarArquivar: 'Archive this template?',
    confirmarArquivarTexto: 'Whoever looks up this code stops receiving the text.',
    inativo: 'Inactive',
    historico: 'Template history',
  },
  estruturas: { tipo: 'Type', tipos: { receita: 'Income', despesa: 'Expense' },
    titulo: 'Stages and roles',
    ajuda: 'These lists belong to other modules. Each one is edited in a single place (roles in People > Roles); rules and history stay in the owner modules.',
    etapas: 'Pipeline stages',
    funcoes: 'People roles',
    editarEm: { funcoes: 'Edit in People > Roles' },
    nomeNovo: 'Name',
    funil: 'Pipeline',
    indisponivel: 'This module does not expose its list for editing here yet. When it does, it shows up in this section.',
    semModulos: 'No module with editable lists is installed (pipeline or people).',
    vazio: 'Nothing yet. Add the first item.',
    confirmarRemover: 'Remove this item?',
    confirmarRemoverTexto: 'The deletion rule belongs to the owner module; if records use the item, it warns you.',
  },
  subsistemas: {
    titulo: 'Subsystems',
    ajuda: 'A subsystem is a menu filter: it decides where each page appears. Who can open the page is still the role permission, and the data is the same in all of them.',
    usar: 'Use subsystems in this workspace',
    usarAjuda: 'Off, the menu is the usual one for everyone. On, each person chooses the company and the subsystem when signing in.',
    usarSoTodas: 'Only someone who sees all companies turns the workspace subsystems on or off. While they are off, your company\'s arrangement is kept, but the menu does not change.',
    novoDesenho: 'New design',
    novoDesenhoAjuda: 'New CRM shell for everyone in this workspace: subsystem at the top, workspace and company in the profile, side menu with only the subsystem pages. Only applies with subsystems on.',
    valerPara: 'Applies to',
    oWorkspace: 'The workspace (all companies)',
    aEmpresa: 'This company: {{nome}}',
    empresaAjuda: 'The company arrangement applies on top of the workspace one.',
    subsistema: 'Subsystem',
    ligadoEm: '{{nome}} on',
    ligadoAjuda: 'Off, it does not appear on the home screen.',
    comum: 'Admin, Settings and the team chat appear in every subsystem.',
    paginasDe: '{{ligadas}} of {{total}} pages',
    paginaCasca: 'Sidebar',
    parcial: 'Partial',
    modulo: '{{nome}} in {{subsistema}}',
    pagina: '{{pagina}} in {{subsistema}}',
    avisoSemLugar_one: '{{count}} page is outside every enabled subsystem and does not appear in the menus.',
    avisoSemLugar_other: '{{count}} pages are outside every enabled subsystem and do not appear in the menus.',
    restaurarSub: 'Restore {{nome}} default',
    restaurarTudo: 'Restore all defaults',
    salvar: 'Save',
    salvo: 'Subsystems saved',
    semMudanca: 'Nothing changed',
    historico: 'Subsystem history',
    trocaWorkspace: 'Workspace arrangement',
    trocaEmpresa: 'Arrangement of company {{nome}}',
    semLugarTitulo: 'Pages without a place in the menus',
    semLugarTexto: 'These pages are outside every enabled subsystem and will no longer appear in the menus:',
    ciente: 'I understand these pages will no longer appear in the menus. The data stays stored and I can turn them back on here.',
    confirmar: 'Confirm and save',
    semPermissao: 'No permission to configure subsystems.',
  },
  icones: {
    titulo: 'Icons on tabs',
    ajuda: 'Icon before the name of page tabs and sub-tabs (the side menu does not change). Applies to the whole workspace.',
    ativo: 'Show icons on tabs',
    celular: 'Also show on mobile',
    celularAjuda: 'Off, icons appear only on larger screens; on mobile the tabs keep only the text.',
    trocar: 'Change the icon of a tab',
    primeiroNivel: 'First level (modules and groups)',
    iconeDe: 'Icon of {{nome}}',
    padrao: 'Default ({{nome}})',
    // Captura do Gustavo (13/10): o nome de cada ícone no idioma do app (o do lucide, em inglês, não aparece na tela).
    nomes: { Activity: 'Activity', ArrowDownLeft: 'Incoming arrow', ArrowLeftRight: 'Two-way arrows', ArrowRightLeft: 'Swap', ArrowUpRight: 'Outgoing arrow', BadgeCheck: 'Approved badge', Banknote: 'Banknote', Bell: 'Bell', BookOpen: 'Open book', Bookmark: 'Bookmark', Bot: 'Robot', Boxes: 'Boxes', Briefcase: 'Briefcase', BriefcaseBusiness: 'Business briefcase', Building: 'Building', Building2: 'Buildings', Calendar: 'Calendar', CalendarCheck: 'Calendar with check', CalendarClock: 'Calendar with clock', CalendarCog: 'Calendar with gear', CalendarDays: 'Calendar with days', CalendarRange: 'Calendar range', Camera: 'Camera', ChartColumn: 'Column chart', ChartLine: 'Line chart', ClipboardCheck: 'Clipboard with check', ClipboardList: 'Clipboard with list', Clock: 'Clock', Code: 'Code', Contact: 'Contact', CreditCard: 'Credit card', Download: 'Download', Factory: 'Factory', FileCheck2: 'File with check', FileLock: 'Locked file', FileMinus: 'File with minus', FileQuestion: 'File with question mark', FileSignature: 'File with signature', FileSpreadsheet: 'Spreadsheet', FileText: 'Document', Folder: 'Folder', FolderKanban: 'Folder with board', Gauge: 'Gauge', Gift: 'Gift', GraduationCap: 'Graduation cap', HandCoins: 'Hand with coins', Handshake: 'Handshake', Hash: 'Hash', Heart: 'Heart', History: 'History', House: 'House', IdCard: 'ID card', Inbox: 'Inbox', Kanban: 'Board', KeyRound: 'Key', Landmark: 'Bank', LayoutDashboard: 'Dashboard', LayoutGrid: 'Grid', LayoutTemplate: 'Page template', LifeBuoy: 'Life buoy', List: 'List', ListTodo: 'To-do list', ListTree: 'Tree list', Lock: 'Lock', Mail: 'Envelope', Megaphone: 'Megaphone', MessageCircle: 'Chat bubble', MessagesSquare: 'Messages', MonitorSmartphone: 'Computer and phone', Network: 'Network', Package: 'Package', PackagePlus: 'Package with plus', Palette: 'Color palette', Percent: 'Percent', PiggyBank: 'Piggy bank', Plug: 'Plug', Puzzle: 'Puzzle', Receipt: 'Receipt', ReceiptText: 'Receipt with text', Repeat: 'Repeat', Route: 'Route', Ruler: 'Ruler', Scale: 'Scale', Settings2: 'Settings', Share2: 'Share', ShieldCheck: 'Shield with check', ShoppingCart: 'Shopping cart', SlidersHorizontal: 'Sliders', Star: 'Star', Store: 'Store', Tags: 'Tags', Target: 'Target', TextCursorInput: 'Text field', ThumbsDown: 'Thumbs down', ToggleLeft: 'Toggle', Trash2: 'Trash', TrendingUp: 'Trending up', TriangleAlert: 'Warning', Truck: 'Truck', UserCheck: 'Person with check', UserCog: 'Person with gear', UserRound: 'Person', Users: 'People', Wallet: 'Wallet', Warehouse: 'Warehouse', Webhook: 'Webhook', Workflow: 'Workflow', Zap: 'Lightning' },
  },
  links: {
    titulo: 'External links',
    ajuda: 'Outside systems (such as the virtual office and the password vault) that appear on the home screen next to the subsystems and open in a new tab or, when allowed, inside MalgoOS. Only https addresses.',
    vazio: 'No links yet.',
    nome: 'Name',
    url: 'Address',
    urlInvalida: 'Use a complete https:// address',
    papeis: 'Who sees it',
    papeisAjuda: 'None checked: everyone in the workspace. Hiding the link does not protect the destination.',
    adicionar: 'Add link',
    remover: 'Remove {{nome}}',
    semNome: 'unnamed link',
    embutir: 'Open inside MalgoOS',
    embutirAjuda: 'Opens in a system page, with the menu alongside, instead of a new tab. On mobile it still opens in a new tab.',
    embutirMotivo: {
      url: 'Enter a valid https:// address to open it inside MalgoOS.',
      host: 'Only allowed addresses open inside MalgoOS (currently: {{hosts}}); this one opens in a new tab.',
      caminho: 'The /admin panel only opens in its own tab.',
    },
  },
  camposTelas: {
    titulo: 'Screen fields',
    ajuda: 'For each record screen, choose which fields are shown and which are required. Hiding does not erase what was already saved. A field with a lock is used in rules, reports or integrations and does not change.',
    tela: 'Screen',
    aparece: 'Shown',
    obrigatorio: 'Required',
    escondido: 'Hidden',
    padrao: 'Default',
    travado: 'Locked',
    travadoDica: 'Used in rules, reports, integrations or calculations',
    salvar: 'Save fields',
    descartar: 'Discard',
    salvo: 'Screen fields saved',
    vazio: 'No installed module has a screen with configurable fields.',
    semPermissao: 'Only people with the permission to configure screen fields see this tab (IT and Administrator; other roles in People > People > Users and access > Roles).',
    soQuemVeTodas: 'Applies to the whole workspace: only people who see all companies can save.',
    historico: 'Screen fields history',
    troca: '{{tela}}: {{lista}}',
  },
  modoOperacao: {
    titulo: 'Operating mode',
    ajuda: 'Choose how deep each module goes in this workspace. Changing deletes nothing: what was already recorded stays available.',
    atual: 'Current',
    padrao: 'module default',
    oQueMuda: 'What changes',
    impede: 'To change, first close: {{lista}}',
    salvar: 'Save mode',
    salvo: 'Operating mode saved',
    vazio: 'No installed module has an operating mode to choose.',
    semPermissao: 'Only people who edit Settings can change the operating mode.',
    historico: 'Change history',
    troca: '{{modulo}}: {{de}} to {{para}}',
  },
  historico: {
    titulo: 'Change history',
    vazio: 'No change recorded yet.',
    por: 'by {{nome}}',
    sistema: 'system',
    chaveApi: 'API key',
    sem: 'no details',
    removido: '(removed)',
    acoes: { criar: 'Created', editar: 'Edited', arquivar: 'Archived', desativar: 'Deactivated', definir: 'Set', remover: 'Removed', distribuir: 'Distributed', devolver: 'Returned to the group' },
  },
};

const es: Dic = {
  nome: 'Configuración',
  papelFabrica: { dono: 'TI', administrador: 'Administrador', gestor: 'Gestor', operador: 'Operador', leitura: 'Solo lectura' },
  abas: {
    subsistemas: 'Subsistemas',
    empresa: 'Empresa',
    aparencia: 'Apariencia',
    modos: 'Modo de operación',
    sequencias: 'Secuencias',
    campos: 'Campos personalizados',
    'campos-telas': 'Campos de las pantallas',
    visoes: 'Vistas guardadas',
    modelos: 'Plantillas',
    estruturas: 'Etapas y funciones',
    crm: 'CRM',
  },
  crm: {
    titulo: 'Configuración del CRM',
    intro: 'Embudos y etapas (con el playbook), motivos de pérdida, fuentes y campañas, calificación, cuestionarios, plantillas de propuesta y workflows comerciales están en la Configuración del CRM.',
    abrir: 'Abrir la Configuración del CRM',
  },
  acoes: { novaEmpresa: 'Nueva empresa', novaSequencia: 'Nueva secuencia', novoCampo: 'Nuevo campo', novoModelo: 'Nueva plantilla', desativar: 'Desactivar', arquivar: 'Archivar', remover: 'Eliminar', adicionar: 'Agregar', renomear: 'Renombrar' },
  empresa: {
    titulo: 'Empresas del grupo',
    razao: 'Razón social',
    fantasia: 'Nombre comercial',
    cnpj: 'CNPJ (identificación fiscal)',
    pais: 'País',
    moeda: 'Moneda predeterminada',
    consulta: { buscando: 'Buscando los datos...', preenchido: 'Datos completados por la consulta; revísalos antes de guardar', naoEncontrado: 'No encontrado en la consulta', falha: 'La consulta no respondió; complétalo a mano' },
    cep: 'Código postal',
    logradouro: 'Calle',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Barrio',
    cidade: 'Ciudad',
    uf: 'Estado',
    endereco: 'Dirección',
    logo: 'Logo',
    enviarLogo: 'Subir logo',
    trocarLogo: 'Cambiar logo',
    removerLogo: 'Quitar logo',
    semLogo: 'Sin logo',
    logoDica: 'Imagen PNG, JPG o SVG de hasta 2 MB. El logo es un adjunto de la empresa.',
    logoGrande: 'El logo supera 2 MB',
    logoTipo: 'Elige una imagen',
    vazio: 'Registra la empresa principal. Aparece en los documentos y en las secuencias de numeración.',
    confirmarArquivar: '¿Eliminar esta empresa?',
    confirmarArquivarTexto: 'No se borra nada: se archiva y sale de las listas y del selector. La última empresa activa no se puede eliminar.',
    historico: 'Historial de la empresa',
    troca: {
      titulo: 'Cambio de empresa/vertical',
      ajuda: 'Define cómo trabajan las personas de este workspace con las empresas (verticales) del grupo.',
      ligar: 'Trabajar con cambio de empresa/vertical',
      ligarAjuda: 'Activado, el selector de empresa aparece en el perfil y cada persona puede trabajar en una vertical. Desactivado, es un entorno único: cada persona ve siempre todas las verticales habilitadas para ella, el registro nuevo nace en "Todas" (o en las verticales de ella, si es limitada) y los registros de un solo CNPJ piden la empresa en el propio formulario. El filtro "Vertical" de las listas continúa.',
      salvar: 'Guardar',
      descartar: 'Descartar',
    },
    exportacoes: {
      titulo: 'Archivos de informe ya exportados sin acceso',
      ajuda: 'Qué pasa con los archivos que una persona ya exportó de un informe cuando pierde la página del informe o el permiso del módulo.',
      bloquear: 'Bloquear los archivos de quien perdió el acceso',
      bloquearAjuda: 'Activado (predeterminado), los archivos salen de la lista de exportaciones y la descarga se rechaza mientras la persona esté sin acceso; si el acceso vuelve, los archivos vuelven (hasta que venzan). Desactivado, los archivos siguen disponibles hasta que venzan. Se aplica a la exportación manual, el informe guardado y el programado; no se borra nada.',
      salvar: 'Guardar',
      descartar: 'Descartar',
    },
  },
  aparencia: {
    titulo: 'Apariencia',
    ajuda: 'El color de marca vale para todo el workspace. El tema e idioma predeterminados valen para quien aún no eligió el suyo.',
    acento: 'Color de marca',
    tema: 'Tema predeterminado',
    idioma: 'Idioma predeterminado',
    previa: 'Vista previa en vivo',
    previaTexto: 'Así quedan el botón principal, los destacados y las pestañas con el color elegido.',
    botao: 'Color del botón principal',
    aba: 'Pestaña activa',
    destaque: 'Destacado',
    salvar: 'Guardar apariencia',
    descartar: 'Descartar',
    cores: { verde: 'Verde Malgo', rosa: 'Rosa', roxo: 'Morado', azul: 'Azul', ciano: 'Cian', laranja: 'Naranja' },
    temas: { escuro: 'Oscuro', claro: 'Claro' },
    idiomas: { pt: 'Português', en: 'English', es: 'Español' },
    historico: 'Historial de la apariencia',
    de: 'de',
    para: 'a',
    modelos: {
      titulo: 'Modelos propios',
      ajuda: 'Crea un modelo a partir de uno de los modos, ajusta los colores y aplícalo al workspace.',
      vazio: 'Aún no hay modelos.',
      novo: 'Nuevo modelo',
      partida: 'Empezar desde',
      nome: 'Nombre del modelo',
      nomePadrao: 'Mi modelo',
      editar: 'Editar',
      aplicar: 'Aplicar a todos',
      emUso: 'En uso',
      excluir: 'Eliminar',
      excluirTitulo: '¿Eliminar este modelo?',
      excluirTexto: 'El workspace vuelve a Marea si este modelo está en uso. Quien tenga este estilo fijado ve Marea hasta recibir otro.',
      salvar: 'Guardar modelo',
      cancelar: 'Cancelar',
      claro: 'Claro',
      escuro: 'Oscuro (Noche)',
      areaPagina: 'Página',
      areaBarra: 'Barra y menú',
      previa: 'Vista previa',
      hexInvalido: 'Usa un hexadecimal de seis dígitos, empezando por almohadilla',
      contrasteOk: 'Contraste aprobado en los dos temas.',
      contrasteFalha_one: '1 combinación sin contraste suficiente. Ajústala para guardar.',
      contrasteFalha_other: '{{count}} combinaciones sin contraste suficiente. Ajústalas para guardar.',
      salvo: 'Modelo guardado',
      contrasteItemSelo: 'Sello de {{frente}} sobre {{fundo}}: {{razao}}:1 (mínimo {{minimo}}:1)',
      contrasteItem: '{{frente}} sobre {{fundo}}: {{razao}}:1 (mínimo {{minimo}}:1)',
      aplicado: 'Modelo aplicado al workspace',
      aplicarAjuda: 'Vale para quien sigue el estándar del workspace. Para que valga para todos, desactiva la elección personal en la tarjeta de arriba.',
      previaTitulo: 'Visión general',
      previaTexto: 'Texto de apoyo de la tarjeta',
      previaValor: 'R$ 93.540,80',
      previaLink: 'Ver detalles',
      previaBotao: 'Guardar',
      previaSecundario: 'Cancelar',
      previaOk: 'Pagado',
      previaAtencao: 'Vence hoy',
      previaErro: 'Vencido',
      previaMenu1: 'Inicio',
      previaMenu2: 'Comercial',
      previaMenu3: 'Actividades',
      tok: {
        fundo: 'Fondo',
        'superficie-1': 'Tarjeta',
        'superficie-2': 'Superficie 2',
        'superficie-3': 'Superficie 3',
        'tinta-1': 'Texto principal',
        'tinta-2': 'Texto de apoyo',
        'tinta-3': 'Leyenda',
        borda: 'Borde',
        'borda-campo': 'Borde de campo',
        campo: 'Fondo de campo',
        foco: 'Anillo de foco',
        acento: 'Botón principal',
        'acento-forte': 'Destacado',
        'acento-hover': 'Botón al pasar el ratón',
        'acento-tinta': 'Texto del botón',
        azul: 'Enlace',
        verde: 'Positivo',
        perigo: 'Error',
        dourado: 'Atención',
        laranja: 'Atraso',
        apoio: 'Información',
      },
    },
    estilo: {
      titulo: 'Estilo de interfaz del workspace',
      ajuda: 'Vale para quien no eligió el suyo y, con la elección personal desactivada, para todos.',
      permitir: 'Permitir que cada persona elija su propio estilo',
      permitirAjuda: 'Desactivado, la tarjeta Estilo de Mi cuenta queda solo de lectura y vale el del workspace (o el fijado para la persona en Usuarios).',
      salvar: 'Guardar estilo',
    },
    fonte: {
      titulo: 'Fuente del texto',
      ajuda: 'Vale para todo el workspace. Los números y valores siguen en la fuente de ancho fijo, para que las columnas no se desalineen.',
      padrao: 'Predeterminada',
      daEmpresa: 'De la empresa',
      sistema: 'Fuente del sistema',
      amostra: 'Acción rápida: código Il1O0, 25 ítems, 98,5%, ñ ¿ ¡',
      permitir: 'Cada persona puede elegir su propia fuente',
      permitirAjuda: 'En Mi cuenta, entre las vistas previas y las fuentes enviadas aquí.',
      salvar: 'Guardar fuente',
      enviarTitulo: 'Enviar archivo de fuente',
      enviarAjuda: 'woff2 hasta {{woff2}} KB, woff hasta {{woff}} KB, ttf y otf hasta {{ttf}} KB. Como máximo 2 archivos (regular y negrita, o una variable).',
      arquivo: 'Archivo de fuente',
      nome: 'Nombre visible',
      licenca: 'Tengo licencia para uso y distribución web de esta fuente',
      licencaAviso: 'Las fuentes del sistema operativo y de paquetes de oficina suelen prohibir el uso en páginas. El sistema rechaza el archivo marcado como de uso restringido.',
      enviar: 'Enviar fuente',
      enviada: 'Fuente enviada',
      removerTitulo: 'Quitar fuente',
      removerTexto: 'La fuente {{nome}} sale de la lista. Quien la usaba vuelve a la fuente del workspace.',
    },
    marca: {
      titulo: 'Marca',
      ajuda: 'Nombre y logo que aparecen en el menú y en el ícono de la pestaña del navegador.',
      nome: 'Nombre visible',
      nomeAjuda: 'Vacío, aparece MalgoOS.',
      salvarNome: 'Guardar nombre',
      logo: 'Logo',
      logoAjuda: 'PNG o WebP hasta 256 KB, de preferencia cuadrado. No se acepta SVG.',
      logoEnviada: 'Logo actualizado',
      enviando: 'Enviando',
      removerLogo: 'Quitar logo',
    },
  },
  sequencias: {
    titulo: 'Secuencias de numeración',
    ajuda: 'Cada documento toma el siguiente número sin huecos ni repeticiones. El siguiente número solo puede subir.',
    codigo: 'Código',
    codigoDica: 'Usado por los módulos: fatura, conta_pagar, pedido_compra, contrato',
    empresa: 'Empresa',
    todasEmpresas: 'Todas las empresas',
    prefixo: 'Prefijo',
    prefixoDica: 'Usa {ano} para el año actual. Ej.: FAT-{ano}-',
    digitos: 'Dígitos',
    proximo: 'Siguiente número',
    proximoDica: 'Debe ser igual o mayor que el actual',
    proximoInvalido: 'El siguiente número empieza en 1',
    digitosInvalido: 'Usa de 1 a 12 dígitos',
    reinicio: 'Reiniciar cada año',
    proxima: 'Próxima numeración',
    previa: 'Vista previa',
    vazio: 'Crea la primera secuencia. Sin ella, el sistema usa un estándar con tres letras del código.',
    novaTitulo: 'Nueva secuencia',
    editarTitulo: 'Editar secuencia',
    historico: 'Historial de las secuencias',
    sim: 'Reinicia',
    nao: 'Continua',
  },
  campos: {
    titulo: 'Campos personalizados',
    ajuda: 'Los campos aparecen en el formulario y en la tabla de la entidad elegida. Solo entran entidades de módulos instalados.',
    entidade: 'Entidad',
    chave: 'Clave',
    chaveDica: 'Nombre interno: minúsculas, números y guion bajo. No cambia después.',
    rotulo: 'Etiqueta',
    tipo: 'Tipo',
    opcoes: 'Opciones de la lista',
    opcoesDica: 'Una opción por línea',
    obrigatorio: 'Obligatorio',
    ordem: 'Orden',
    tipos: { texto: 'Texto', numero: 'Número', data: 'Fecha', lista: 'Lista', booleano: 'Sí o no', telefone: 'Teléfono', documento: 'CPF o CNPJ', email: 'Correo', cep: 'Código postal', dinheiro: 'Dinero', texto_longo: 'Texto largo' },
    ajudaCampo: 'Ayuda', ajudaCampoDica: 'Aparece debajo del campo en el formulario (hasta 200 caracteres).', condicao: 'Mostrar cuando', condicaoDica: 'Opcional: el campo solo aparece cuando este otro campo tiene el valor elegido.', condicaoValor: 'Sea igual a', condicaoSelo: 'Condicional', soNestaAba: 'Solo en {{aba}}', soNestaAbaDica: 'Sin marcar, el campo vale en las dos pestañas (Empresas y Contactos).', soNaAba: 'Este campo vale solo en {{aba}}.', nasDuasAbas: 'En las dos pestañas',
    condicaoFixos: { tipo: 'Tipo (persona o empresa)', e_cliente: 'Es cliente', e_fornecedor: 'Es proveedor', e_parceiro: 'Es referidor / socio comercial' },
    condicaoValores: { pessoa: 'Persona', empresa: 'Empresa', true: 'Sí', false: 'No' },
    vazio: 'Ningún campo en esta entidad. Crea el primero para que aparezca en los formularios.',
    novoTitulo: 'Nuevo campo personalizado',
    editarTitulo: 'Editar campo',
    tipoFixo: 'La clave y el tipo no cambian, porque los valores guardados dependen de ellos.',
    sensivel: 'Dato sensible (oculto en el modo discreto)',
    sensivelDica: 'Con el modo discreto activado, el valor se oculta en la ficha, la tabla, el formulario y la auditoría.',
    sensivelSempre: 'Los números, las fechas, el dinero, los documentos, los teléfonos, los correos y los códigos postales siempre se ocultan en el modo discreto.',
    sensivelSelo: 'Sensible',
    confirmarDesativar: '¿Desactivar este campo?',
    confirmarDesativarTexto: 'Sale de los formularios y las tablas. Los valores guardados se conservan.',
    semEntidades: 'Ningún módulo instalado acepta campos personalizados.',
    historico: 'Historial de los campos',
    entidades: {
      cadastros_parceiro: 'Socios (registros)',
      cadastros_projeto: 'Proyectos (registros)',
      pipeline_oportunidade: 'Oportunidades (pipeline)',
      estoque_produto: 'Productos (inventario)',
      pessoas_funcionario: 'Empleados (personas)',
      agenda_agendamento: 'Citas (agenda)',
      financeiro_lancamento: 'Asientos (finanzas)',
      contas_documento: 'Documentos (cuentas)',
      compras_pedido: 'Pedidos (compras)',
      cadastros_servico: 'Servicios (registros)',
      assinaturas_contrato: 'Contratos (suscripciones)',
      compras_requisicao: 'Requisiciones (compras)',
      folha_beneficio: 'Beneficios (nómina)',
      folha_evento: 'Eventos (nómina)',
      cadastros_forma_pagamento: 'Formas de pago (registros)',
      cadastros_condicao_pagamento: 'Condiciones de pago (registros)',
      compras_compra: 'Compras directas (compras)',
    },
  },
  visoes: {
    titulo: 'Mis vistas guardadas',
    ajuda: 'Las vistas son filtros, columnas y orden que guardaste en las tablas. Solo tú editas y eliminas las tuyas; las que compartes aparecen para quien las recibió.',
    compartilhamentos: { papeis: 'Compartida con roles', pessoas: 'Compartida con personas', workspace: 'Compartida con todo el workspace' },
    emRelatorios: 'En Informes',
    tela: 'Pantalla',
    todasTelas: 'Todas las pantallas',
    padrao: 'Predeterminada',
    colunas_one: '{{count}} columna', colunas_other: '{{count}} columnas',
    vazio: 'Aún no guardaste ninguna vista. En las tablas, usa el icono de marcador para guardar la vista actual.',
    confirmarRemover: '¿Eliminar esta vista?',
    confirmarRemoverTexto: 'Deja de aparecer en la tabla. Los datos no cambian.',
    historico: 'Historial de las vistas',
  },
  modelos: {
    titulo: 'Plantillas de mensaje y documento',
    ajuda: 'Los módulos buscan la plantilla por código y reemplazan las variables con los datos del cliente.',
    codigo: 'Código',
    codigoDica: 'No cambia después, porque otros módulos usan este código',
    nome: 'Nombre',
    tipo: 'Tipo',
    canal: 'Canal',
    assunto: 'Asunto',
    corpo: 'Cuerpo',
    ativo: 'Activa',
    variaveis: 'Variables',
    variaveisDica: 'Haz clic para insertar en el cuerpo',
    previa: 'Vista previa con datos de ejemplo',
    previaCarregando: 'Armando la vista previa',
    tipos: { mensagem: 'Mensaje', documento: 'Documento' },
    canais: { email: 'Correo', whatsapp: 'WhatsApp' },
    var: { nome: 'Nombre del cliente', valor: 'Valor', vencimento: 'Vencimiento o fecha de referencia', link: 'Enlace', pix: 'Pix copia y pega (del cobro generado)', linha_digitavel: 'Línea digitable del boleto (del cobro generado)', pix_copia_e_cola: 'Pix copia y pega (Asaas o Pix Sicredi)', link_portal: 'Enlace de la factura en el Portal (cliente con acceso)', como_pagar: 'Cómo pagar: enlace, Pix, línea digitable o Portal (lo que haya)' },
    vazio: 'Crea la primera plantilla para estandarizar cobros, recordatorios y bienvenidas.',
    novoTitulo: 'Nueva plantilla',
    editarTitulo: 'Editar plantilla',
    confirmarArquivar: '¿Archivar esta plantilla?',
    confirmarArquivarTexto: 'Quien busque este código deja de recibir el texto.',
    inativo: 'Inactiva',
    historico: 'Historial de las plantillas',
  },
  estruturas: { tipo: 'Tipo', tipos: { receita: 'Ingreso', despesa: 'Gasto' },
    titulo: 'Etapas y funciones',
    ajuda: 'Estas listas pertenecen a otros módulos. Cada una se edita en un solo lugar (los puestos, en Personas > Puestos); la regla y el historial siguen en los módulos dueños.',
    etapas: 'Etapas del pipeline',
    funcoes: 'Funciones de personas',
    editarEm: { funcoes: 'Editar en Personas > Puestos' },
    nomeNovo: 'Nombre',
    funil: 'Embudo',
    indisponivel: 'Este módulo aún no expone la lista para editar aquí. Cuando lo haga, aparece en esta sección.',
    semModulos: 'No hay instalado ningún módulo con listas editables (pipeline o personas).',
    vazio: 'Nada registrado aún. Agrega el primer elemento.',
    confirmarRemover: '¿Eliminar este elemento?',
    confirmarRemoverTexto: 'La regla de eliminación es del módulo dueño; si hay registros usándolo, te avisa.',
  },
  subsistemas: {
    titulo: 'Subsistemas',
    ajuda: 'El subsistema es un filtro de menú: decide dónde aparece cada página. Quién puede abrir la página sigue siendo el permiso del rol, y los datos son los mismos en todos.',
    usar: 'Usar subsistemas en este workspace',
    usarAjuda: 'Desactivado, el menú es el de siempre para todos. Activado, cada persona elige la empresa y el subsistema al entrar.',
    usarSoTodas: 'Solo quien ve todas las empresas activa o desactiva los subsistemas del workspace. Mientras estén desactivados, la organización de tu empresa se guarda, pero el menú no cambia.',
    novoDesenho: 'Nuevo diseño',
    novoDesenhoAjuda: 'Nueva estructura del CRM para todos en este workspace: subsistema arriba, workspace y empresa en el perfil, menú lateral solo con las páginas del subsistema. Solo vale con los subsistemas activados.',
    valerPara: 'Aplicar a',
    oWorkspace: 'El workspace (todas las empresas)',
    aEmpresa: 'Esta empresa: {{nome}}',
    empresaAjuda: 'La organización de la empresa vale por encima de la del workspace.',
    subsistema: 'Subsistema',
    ligadoEm: '{{nome}} activado',
    ligadoAjuda: 'Desactivado, no aparece en la pantalla inicial.',
    comum: 'Admin, Configuración y el chat del equipo aparecen en todos los subsistemas.',
    paginasDe: '{{ligadas}} de {{total}} páginas',
    paginaCasca: 'Barra lateral',
    parcial: 'Parcial',
    modulo: '{{nome}} en {{subsistema}}',
    pagina: '{{pagina}} en {{subsistema}}',
    avisoSemLugar_one: '{{count}} página está fuera de todos los subsistemas activados y no aparece en los menús.',
    avisoSemLugar_other: '{{count}} páginas están fuera de todos los subsistemas activados y no aparecen en los menús.',
    restaurarSub: 'Restaurar valores de {{nome}}',
    restaurarTudo: 'Restaurar todos los valores',
    salvar: 'Guardar',
    salvo: 'Subsistemas guardados',
    semMudanca: 'Nada cambió',
    historico: 'Historial de los subsistemas',
    trocaWorkspace: 'Organización del workspace',
    trocaEmpresa: 'Organización de la empresa {{nome}}',
    semLugarTitulo: 'Páginas sin lugar en los menús',
    semLugarTexto: 'Estas páginas quedan fuera de todos los subsistemas activados y dejan de aparecer en los menús:',
    ciente: 'Entiendo que estas páginas dejan de aparecer en los menús. Los datos siguen guardados y puedo volver a activarlas aquí.',
    confirmar: 'Confirmar y guardar',
    semPermissao: 'Sin permiso para configurar los subsistemas.',
  },
  icones: {
    titulo: 'Íconos en las pestañas',
    ajuda: 'Ícono antes del nombre de las pestañas y subpestañas de las páginas (el menú lateral no cambia). Vale para todo el workspace.',
    ativo: 'Mostrar íconos en las pestañas',
    celular: 'Mostrar también en el móvil',
    celularAjuda: 'Desactivado, los íconos aparecen solo en pantallas grandes; en el móvil las pestañas quedan solo con el texto.',
    trocar: 'Cambiar el ícono de una pestaña',
    primeiroNivel: 'Primer nivel (módulos y grupos)',
    iconeDe: 'Ícono de {{nome}}',
    padrao: 'Predeterminado ({{nome}})',
    // Captura do Gustavo (13/10): o nome de cada ícone no idioma do app (o do lucide, em inglês, não aparece na tela).
    nomes: { Activity: 'Actividad', ArrowDownLeft: 'Flecha de entrada', ArrowLeftRight: 'Flechas a ambos lados', ArrowRightLeft: 'Intercambio', ArrowUpRight: 'Flecha de salida', BadgeCheck: 'Sello de aprobado', Banknote: 'Billete', Bell: 'Campana', BookOpen: 'Libro abierto', Bookmark: 'Marcador', Bot: 'Robot', Boxes: 'Cajas', Briefcase: 'Maletín', BriefcaseBusiness: 'Maletín ejecutivo', Building: 'Edificio', Building2: 'Edificios', Calendar: 'Calendario', CalendarCheck: 'Calendario con visto', CalendarClock: 'Calendario con reloj', CalendarCog: 'Calendario con engranaje', CalendarDays: 'Calendario con días', CalendarRange: 'Rango en el calendario', Camera: 'Cámara', ChartColumn: 'Gráfico de columnas', ChartLine: 'Gráfico de líneas', ClipboardCheck: 'Portapapeles con visto', ClipboardList: 'Portapapeles con lista', Clock: 'Reloj', Code: 'Código', Contact: 'Contacto', CreditCard: 'Tarjeta de crédito', Download: 'Descargar', Factory: 'Fábrica', FileCheck2: 'Archivo con visto', FileLock: 'Archivo con candado', FileMinus: 'Archivo con menos', FileQuestion: 'Archivo con interrogación', FileSignature: 'Archivo con firma', FileSpreadsheet: 'Hoja de cálculo', FileText: 'Documento', Folder: 'Carpeta', FolderKanban: 'Carpeta con tablero', Gauge: 'Indicador', Gift: 'Regalo', GraduationCap: 'Birrete', HandCoins: 'Mano con monedas', Handshake: 'Apretón de manos', Hash: 'Almohadilla', Heart: 'Corazón', History: 'Historial', House: 'Casa', IdCard: 'Credencial', Inbox: 'Bandeja de entrada', Kanban: 'Tablero', KeyRound: 'Llave', Landmark: 'Banco', LayoutDashboard: 'Panel', LayoutGrid: 'Cuadrícula', LayoutTemplate: 'Plantilla de página', LifeBuoy: 'Salvavidas', List: 'Lista', ListTodo: 'Lista de tareas', ListTree: 'Lista en árbol', Lock: 'Candado', Mail: 'Sobre', Megaphone: 'Megáfono', MessageCircle: 'Globo de conversación', MessagesSquare: 'Mensajes', MonitorSmartphone: 'Computadora y celular', Network: 'Red', Package: 'Paquete', PackagePlus: 'Paquete con más', Palette: 'Paleta de colores', Percent: 'Porcentaje', PiggyBank: 'Alcancía', Plug: 'Enchufe', Puzzle: 'Rompecabezas', Receipt: 'Recibo', ReceiptText: 'Recibo con texto', Repeat: 'Repetir', Route: 'Ruta', Ruler: 'Regla', Scale: 'Balanza', Settings2: 'Ajustes', Share2: 'Compartir', ShieldCheck: 'Escudo con visto', ShoppingCart: 'Carrito de compras', SlidersHorizontal: 'Controles deslizantes', Star: 'Estrella', Store: 'Tienda', Tags: 'Etiquetas', Target: 'Objetivo', TextCursorInput: 'Campo de texto', ThumbsDown: 'Pulgar abajo', ToggleLeft: 'Interruptor', Trash2: 'Papelera', TrendingUp: 'Tendencia al alza', TriangleAlert: 'Alerta', Truck: 'Camión', UserCheck: 'Persona con visto', UserCog: 'Persona con engranaje', UserRound: 'Persona', Users: 'Personas', Wallet: 'Billetera', Warehouse: 'Almacén', Webhook: 'Webhook', Workflow: 'Flujo', Zap: 'Rayo' },
  },
  links: {
    titulo: 'Enlaces externos',
    ajuda: 'Sistemas externos (como la oficina virtual y la bóveda de contraseñas) que aparecen en la pantalla inicial junto a los subsistemas y se abren en una pestaña nueva o, cuando está permitido, dentro de MalgoOS. Solo direcciones https.',
    vazio: 'Ningún enlace registrado.',
    nome: 'Nombre',
    url: 'Dirección',
    urlInvalida: 'Usa una dirección https:// completa',
    papeis: 'Quién lo ve',
    papeisAjuda: 'Ninguno marcado: todos del workspace. Ocultar el enlace no protege el destino.',
    adicionar: 'Agregar enlace',
    remover: 'Quitar {{nome}}',
    semNome: 'enlace sin nombre',
    embutir: 'Abrir dentro de MalgoOS',
    embutirAjuda: 'Se abre en una página del sistema, con el menú al lado, en lugar de una pestaña nueva. En el celular sigue abriéndose en una pestaña nueva.',
    embutirMotivo: {
      url: 'Ingresa una dirección https:// válida para abrirla dentro de MalgoOS.',
      host: 'Solo las direcciones permitidas se abren dentro de MalgoOS (hoy: {{hosts}}); esta se abre en una pestaña nueva.',
      caminho: 'El panel /admin solo se abre en su propia pestaña.',
    },
  },
  camposTelas: {
    titulo: 'Campos de las pantallas',
    ajuda: 'Elige, para cada pantalla de registro, qué campos aparecen y cuáles son obligatorios. Ocultar no borra lo que ya se guardó. El campo con candado se usa en reglas, informes o integraciones y no cambia.',
    tela: 'Pantalla',
    aparece: 'Aparece',
    obrigatorio: 'Obligatorio',
    escondido: 'Oculto',
    padrao: 'Predeterminado',
    travado: 'Bloqueado',
    travadoDica: 'Se usa en reglas, informes, integraciones o cálculos',
    salvar: 'Guardar campos',
    descartar: 'Descartar',
    salvo: 'Campos de la pantalla guardados',
    vazio: 'Ningún módulo instalado tiene pantalla con campos configurables.',
    semPermissao: 'Solo quien tiene el permiso de configurar los campos de las pantallas ve esta pestaña (TI y Administrador; otro rol en Personas > Personas > Usuarios y accesos > Roles).',
    soQuemVeTodas: 'Vale para todo el workspace: solo quien ve todas las empresas guarda.',
    historico: 'Historial de los campos de las pantallas',
    troca: '{{tela}}: {{lista}}',
  },
  modoOperacao: {
    titulo: 'Modo de operación',
    ajuda: 'Elige qué tan a fondo va cada módulo en este workspace. Cambiar no borra nada: lo que ya se registró sigue disponible para consulta.',
    atual: 'Actual',
    padrao: 'predeterminado del módulo',
    oQueMuda: 'Qué cambia',
    impede: 'Para cambiar, primero cierra: {{lista}}',
    salvar: 'Guardar modo',
    salvo: 'Modo de operación guardado',
    vazio: 'Ningún módulo instalado tiene modo de operación para elegir.',
    semPermissao: 'Solo quien edita la Configuración cambia el modo de operación.',
    historico: 'Historial de cambios',
    troca: '{{modulo}}: {{de}} a {{para}}',
  },
  historico: {
    titulo: 'Historial de cambios',
    vazio: 'Aún no hay cambios registrados.',
    por: 'por {{nome}}',
    sistema: 'sistema',
    chaveApi: 'clave de API',
    sem: 'sin detalles',
    removido: '(eliminado)',
    acoes: { criar: 'Creó', editar: 'Editó', arquivar: 'Archivó', desativar: 'Desactivó', definir: 'Definió', remover: 'Eliminó', distribuir: 'Distribuyó', devolver: 'Devolvió al grupo' },
  },
};

export const i18n = { pt, en, es };
